export default {"src":"/_next/static/media/white-globe.b689244a.svg","height":28,"width":28};